module.exports = __webpack_public_path__ + "img/slika-1.cd2745e8.png";